<div class="modal-header">
  <div class="w-100">
    <span class="modal-title fs-4">Sua sessão vai expirar</span>
  </div>
</div>
<div class="modal-body session-expiry">
  <p class="session-expiry__texto">
    Por segurança, você será desconectado em
    <strong class="session-expiry__contador">{{ rotuloContagem() }}</strong>.
  </p>
  <p class="session-expiry__hint">
    Clique em "Continuar conectado" para permanecer na aplicação sem perder o que está preenchendo.
  </p>
</div>
<div class="modal-footer">
  <br-button ariaLabel="Sair agora" [emphasis]="'secondary'" (click)="sair()">Sair agora</br-button>
  <br-button ariaLabel="Continuar conectado" [emphasis]="'primary'" (click)="continuar()"
    >Continuar conectado</br-button
  >
</div>
